import React from "react";
import { ConfigProvider } from "antd";
import viVN from "antd/locale/vi_VN"; // Import ngôn ngữ Tiếng Việt
import LoveConsultant from "./LoveConsultant";
import "./App.css";

// Custom Theme Token
const loveTheme = {
  token: {
    fontFamily: "'Lexend Deca', sans-serif",
    colorPrimary: "#eb2f96", // Hồng đậm chủ đạo
    borderRadius: 16, // Bo góc lớn tạo cảm giác mềm mại
    colorBgContainer: "rgba(255, 255, 255, 0.6)", // Background trong suốt cho input
    colorTextHeading: "#5c3a58",
    boxShadow: "none", // Bỏ shadow mặc định để dùng glass shadow
  },
  components: {
    Button: {
      colorPrimary: "#eb2f96",
      algorithm: true, // Enable thuật toán tính màu hover tự động
      fontWeight: 500,
      controlHeightLG: 50,
      boxShadow: "0 4px 14px 0 rgba(235, 47, 150, 0.39)", // Shadow hồng phát sáng
    },
    Input: {
      activeBorderColor: "#eb2f96",
      hoverBorderColor: "#ffadd2",
      paddingBlock: 8,
    },
    Select: {
      controlHeight: 40,
    },
    Card: {
      headerBg: "transparent", // Header trong suốt để hòa vào kính
    },
  },
};

function App() {
  return (
    <ConfigProvider theme={loveTheme} locale={viVN}>
      <div className="love-background">
        <LoveConsultant />
      </div>
    </ConfigProvider>
  );
}

export default App;
